export const environment = {
  production: true,
  graphqlUrl: 'https://graph6.zalamo.com/photographer-client',
  wssGraphqlUrl: 'wss://graph6.zalamo.com/photographer-client',
  get imagesUrl() {
    return 'https://obrazki7.zalamo.com';
  },
  sessionUrl: 'https://sesje.zalamo.com',
  renderUrl: 'https://lbrender.zalamo.com/render-album',
  zipServer: 'https://zip.zalamo.com',
  orderDetailsUrl: 'https://zamowienia.zalamo.com/',
  version: 943,
};
